/* eslint-disable no-undef */
/* eslint-disable jsx-a11y/alt-text */
import React, { useEffect, useState, useRef } from "react";
import { Link, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";

import "./Home.css";

import { setCartQuantity } from "../../../features/cartQuantity/cartQuantitySlice";

import axios from "../../../api/axios";
import { CART_DETAILS_CONFIG_URL } from "../../../api/api_routing_urls";

import horizontalBgImage from "../../../assets/desktopwtextdiscbg.jpg";
import verticalBgImage from "../../../assets/mob-banner-new.jpg";

import firstSectionDesktopImg from "../../../assets/2025/banner-images/desktopBanner02012026.avif";
import firstSectionMobileImg from "../../../assets/2025/banner-images/mobileBanner02012026.avif";
import secondSectionImg from "../../../assets/2025/banner-images/secondSection.jpg";
import thirdSectionImg from "../../../assets/2025/banner-images/thirdSection.jpg";

import CookieModal from "../../../reusable-components/modals/CookieModal";

import AnimatedLoader from "../../../reusable-components/loader/animated_loader.component";
  
const HomeNew = () => {
  const dispatch = useDispatch();
  const location = useLocation();

  const auth = useSelector((state) => state.authProvider.auth);

  const user_id = auth?.user_id;
  const cartQuantity = useSelector((state) => state.cartQuantity.cartQuantity);

  const [isCookieModalOpen, setIsCookieModalOpen] = useState(true);

  const bannerHomePage = useRef();

  const [isLoading, setIsLoading] = useState(false);

  const [firstDivHeight, setFirstDivHeight] = useState(0);
  const [isBannerDiv, setIsBannerDiv] = useState(true);

  const getCartItemsQuantityDetails = async (user_id) => {
    try {
      const response = await axios.get(
        `${CART_DETAILS_CONFIG_URL}/getTotalItems`,
        {
          params: {
            user_id,
          },
        }
      );
      // console.log("Total items in cart", { response });
      if (response.status === 200) {
        dispatch(setCartQuantity(+response?.data?.cartItemsQuantityDetails));
      } else if (response.status === 202) {
        console.log("No details found in the system.");
      }
    } catch (error) {
      console.error("getCartItemsQuantityDetails", error);
      if (!error?.response) {
        console.log("No Server Response");
      } else if (error.response.status === 422) {
        console.log("Some of the required inputs were not provided.");
      } else {
        console.log(
          "Whoops!!!! This doesn't feel right. There might be an issue. Please contact the administrator."
        );
      }
    }
  };

  //useEffect to fetch the total items in cart of a logged-in user
  useEffect(() => {
    let isMounted = true;

    if (isMounted && user_id) {
      getCartItemsQuantityDetails(user_id);
    }

    return () => {
      isMounted = false;
    };
  }, [user_id]);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  };

  useEffect(() => {
    if (localStorage.getItem("CookieModal") == "true") {
      setIsCookieModalOpen(false);
    }
  }, []);

  // Section to handle text color of glassy filter in mobile phones

  useEffect(() => {
    // console.log("bannerHomePage", bannerHomePage);
    if (bannerHomePage?.current?.offsetHeight > 0) {
      setFirstDivHeight(bannerHomePage?.current?.offsetHeight);
    }
  }, [bannerHomePage?.current?.offsetHeight]);

  useEffect(() => {
    const updateFilterTextColor = () => {
      if (window.scrollY >= firstDivHeight / 5) {
        setIsBannerDiv(false);
      } else {
        setIsBannerDiv(true);
      }
    };

    window.addEventListener("scroll", updateFilterTextColor);

    return () => window.removeEventListener("scroll", updateFilterTextColor);
  }, [firstDivHeight]);

  return (
    <>
      {isLoading ? (
        <div className="bg-white h-screen flex items-center justify-center">
          <AnimatedLoader />
        </div>
      ) : (
        <section className="noSelect font-tenorsans">
          {isCookieModalOpen && (
            <>
              <CookieModal
                title={"your cookie settings"}
                message={`By clicking "Accept All Cookies", you agree to the
         storing of cookies on your device to enhance site
         navigation, analyze site usage, and assist in our 
         marketing efforts. `}
                setIsCookieModalOpen={setIsCookieModalOpen}
              />
            </>
          )}

          <article>
            <div className="relative">
              <div className="hidden lg:block">
                <div className="relative">
                  <img
                    src={firstSectionDesktopImg}
                    className="object-cover w-full"
                  />

                  {/* <Link to="/home/explore-products">
                    <div className="cursor-pointer absolute bottom-[35%] md:bottom-[10%] left-[50%] transform -translate-x-1/2 font-light text-xs text-white">
                      <span className="uppercase underline underline-offset-4 text-[10px]">
                        Explore
                      </span>
                    </div>
                  </Link> */}

                  <Link to="/home/explore-products">
                    <div className="cursor-pointer absolute top-[28%] left-[50%] transform -translate-x-1/2">
                      <span className="uppercase text-xl text-gray-500 font-semibold px-16 py-2 border rounded bg-[#F7F7F7] bg-clip-padding backdrop-filter backdrop-blur-xl bg-opacity-40">
                        Shop
                      </span>
                    </div>
                  </Link>
                </div>
              </div>
            </div>

            <div className="relative">
              <div className="block lg:hidden">
                <div className="relative">
                  <img
                    src={firstSectionMobileImg}
                    className="min-h-screen object-cover w-full"
                  />

                  {/* <Link to="/home/explore-products">
                    <div className="cursor-pointer absolute bottom-[15%] md:bottom-[10%] left-[50%] transform -translate-x-1/2 font-light text-xs text-white">
                      <span className="uppercase underline underline-offset-4 text-[10px]">
                        Explore
                      </span>
                    </div>
                  </Link> */}

                  <Link to="/home/explore-products">
                    <div className="cursor-pointer absolute top-[38%] md:top-[40%] left-[50%] transform -translate-x-1/2 font-light text-xs text-white">
                      <span className="uppercase text-xs md:text-sm text-white font-semibold px-6 md:px-10 py-2 border rounded bg-[#F7F7F7] bg-clip-padding backdrop-filter backdrop-blur-xl bg-opacity-40">
                        Shop
                      </span>
                    </div>
                  </Link>
                </div>
              </div>
            </div>

            {/* <div>
              <img src={secondSectionImg} className="object-cover w-full" />
            </div>

            <div>
              <img src={thirdSectionImg} className="object-cover w-full" />
            </div> */}
          </article>
        </section>
      )}
    </>
  );
};
export default HomeNew;
